export default (theme) => ({
  wrapper: {
    width: '100vw',
    minHeight: '100vh',
    boxSizing: 'border-box',
    border: `1px solid ${theme.palette.background.main}`,
  },
  header: {
    boxSizing: 'border-box',
    display: 'flex',
    width: '100%',
    height: 48,
    borderBottom: `2px solid ${theme.palette.background.main}`,
    padding: '0 12px',
  },
  logoWrapper: {
    display: 'flex',
    width: 42,
  },
  logo: {
    margin: 'auto',
  },
  headerContent: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '0 24px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  userData: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  avatar: {
    marginLeft: 8,
  },
  pageContent: {
    height: 'calc(100% - 72px)',
    padding: 12,
  },
  loadingPageContent: {
    padding: 0,
  },
  idWrapper: {
    whiteSpace: 'nowrap',
  },
  loaderWrapper: {
    height: 'calc(100% - 48px)',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  transparentLoaderWrapper: {
    position: 'absolute',
    marginTop: 48,
    top: 0,
    left: 0,
    zIndex: 100,
  },
  transparentLoaderBg: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: theme.palette.cardBackground,
    opacity: 0.6,
    zIndex: 100,
  },
  progressWrapper: {
    position: 'relative',
    zIndex: 101,
  },
});
